module.exports = __webpack_public_path__ + "img/intro-long-active.9a59961a.png";